import React from "react";
import { Link } from "react-router-dom";
import { slugToCountryPathname } from "../../utils/strings";
import { ArrowRight } from "@speedoc/design-assets/build/icons";
import { useMediaQuery } from "react-responsive";
import ContainerCard from "./containerCard";

const UpdateCard = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 992px)" });

  return (
    <ContainerCard>
      <div className="updateCard" style={{ backgroundImage: `url(${content.image.url})` }}>
        <div className="title">{content.title}</div>
        <div className="description">{content.description}</div>
        <div className="link">
          {isMobile ? (
            content.link.text
          ) : (
            <Link to={slugToCountryPathname(content.link.path)}>{content.link.text}</Link>
          )}
          <ArrowRight className="arrow right" />
        </div>
      </div>
    </ContainerCard>
  );
};

export default UpdateCard;
